import { GlobalConfiguration } from "../../../utils/configurationProvider";
import BeneCategoryImageChecker from "../../Accounts/BeneCategoryImageChecker";
import TickerAnimation from "../TickerAnimation";
/**

@param {OnClickEventHandler} props.handledata,  - category data are showing
@param {string} props.logoIcon - icon/SVG image path to display
@param {string} props.category_url - Category path URL display on card
@param {OnClickEventHandler} props.SelectedbackgroundColour - category selection function
@param {Object} props.handleCategorySelect - All category are showing to card
 @param {string} [props.categoryNameColour] - categoryName Font colour 
 @param {string} [props.categoryTextSize] - categoryName Font Size 
  @param {string} [props.categoryFontWeight] - categoryName Font weight 
  
*/

const CategoriesCard = ({
  handledata,
  logoIcon,
  category_url,
  SelectedbackgroundColour,
  handleCategorySelect,
  categoryNameColour,
  categoryTextSize,
  categoryFontWeight,
  flow,
}) => {
  return (
    <>
      <div
        key={handledata.id}
        onClick={() => {
          handleCategorySelect(handledata.id);
        }}
        className={`bg-primary-nav rounded-border-radius-md mr-margin-md flex ${flow === "switch_account" ? "cursor-not-allowed" : "cursor-pointer"}`}
      >
        <div className="p-padding-sm border-r flex items-center  bg-text-primary rounded-l-border-radius-md">
          <div className="w-icon-lg">
            <BeneCategoryImageChecker category_url={category_url} />
          </div>
        </div>

        <div
          className={`flex w-full group relative bg-primary-nav ${flow === "switch_account" ? "" : "global-hover-white"} rounded-r-border-radius-md z-z-index-base transition-colors duration-animation-fast-s overflow-auto`}
        >
          <div
            class={`absolute bg-positive-bg ${flow === "switch_account" ? "" : "group-hover:bg-positive-bg-hover"} z-z-index-header`}
            style={{
              transform:
                SelectedbackgroundColour === "primary-nav"
                  ? "scale(0)"
                  : "scale(1)",
              transformOrigin: "right",
              transition:
                SelectedbackgroundColour === "primary-nav"
                  ? "transform var(--animation-fast-xs) ease-in"
                  : "transform var(--animation-fast-s) ease-in",
              height: "var(--height-full)",
              width: "calc(var(--width-full) - var(--icon-lg))",
            }}
          ></div>
          <div
            class={`absolute bg-positive-bg ${flow === "switch_account" ? "" : "group-hover:bg-positive-bg-hover"} z-z-index-header`}
            style={{
              transform:
                SelectedbackgroundColour === "primary-nav"
                  ? "scale(0)"
                  : "scale(1)",
              transformOrigin: "left",
              transition:
                SelectedbackgroundColour === "primary-nav"
                  ? "transform var(--animation-fast-xs) ease-in"
                  : "transform var(--animation-fast-s) ease-in",
              left: "calc(var(--left-full) - var(--icon-lg))",
              height: "var(--height-full)",
              width: "var(--icon-lg)",
              borderRadius:
                "var(--border-base) var(--border-radius-md) var(--border-radius-md) var(--border-base)",
            }}
          ></div>
          <div className="w-full flex flex-col justify-center pl-padding-sm min-w-0 relative z-[unset] gap-gap-xs">
            <p className="text-text-primary relative z-z-index-header text-font-sm font-semibold">
              <TickerAnimation
                text={
                  handledata?.name
                    .charAt(GlobalConfiguration?.lengthCheckZero)
                    .toUpperCase() +
                  handledata?.name.slice(GlobalConfiguration?.lengthCheckOne)
                }
              />
            </p>
            {handledata?.description && (
              <p className="text-text-secondary text-font-xs relative z-z-index-header font-normal">
                <TickerAnimation text={handledata?.description} />
              </p>
            )}
          </div>

          <div
            className={` flex justify-end relative z-[unset] ${
              !logoIcon ? "pr-padding-md" : "p-padding-md"
            }`}
          >
            {logoIcon && (
              <div className="w-icon-md relative z-z-index-header">
                <img
                  src={logoIcon}
                  alt={SelectedbackgroundColour ? "selected" : "not selected"}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoriesCard;
